/** Map noisy provider errors to a simple prompt-focused message. */
export function imageGenerationUserMessage(backendMessage: string): string {
  const m = backendMessage.trim();
  if (
    /may be down|invalid credentials|different provider|check api logs|gemini api|ideogram|billing|quota|failed to generate/i.test(
      m
    )
  ) {
    return "Please specify a clearer image prompt: one short scene (who, what, where). Do not paste your full script.";
  }
  return m;
}
